import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Container({ children, className = "" }) {
  return <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle, center = false, light = false }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} mb-12`}>
      {eyebrow && (
        <span className={`inline-block text-xs font-semibold uppercase tracking-[0.18em] mb-3 ${light ? "text-[#34D399]" : "text-[#10B981]"}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`text-3xl sm:text-4xl lg:text-[2.7rem] font-bold tracking-tight font-display text-balance ${light ? "text-white" : "text-[#0F172A]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-lg leading-relaxed ${light ? "text-slate-300" : "text-[#475569]"}`}>{subtitle}</p>
      )}
    </div>
  );
}

export function PrimaryLink({ to, children, testId, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-xl bg-[#10B981] px-7 py-3.5 text-sm font-semibold text-white hover:bg-[#059669] transition-all shadow-sm hover:shadow-md ${className}`}
    >
      {children}
      <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
    </Link>
  );
}

export function SecondaryLink({ to, children, testId, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 rounded-xl border-2 border-[#E2E8F0] bg-white px-7 py-3.5 text-sm font-semibold text-[#0F172A] hover:border-[#0F172A] transition-colors ${className}`}
    >
      {children}
    </Link>
  );
}
